import React, { ReactElement, FunctionComponent } from "react";
import { ResponsiveLine } from "@nivo/line";
import { GraphProps } from "../../../wrappers/LoadingGraph";
import { YoyAdsRecord } from "../../../redux/types/reportTypes";

type LinePoint = { x: string; y: number };
type LineRecord = { id: string; data: Array<LinePoint> };

const YoyAdsGraph: FunctionComponent<GraphProps> = ({
  records,
}: GraphProps): ReactElement => {
  const data = () =>
    records.reduce<LineRecord[]>((acc, record) => {
      const yoy = record as YoyAdsRecord;
      const year = acc.find((y) => y.id === yoy.year);
      if (!year) acc.push({ id: yoy.year, data: [{ x: yoy.week, y: yoy.count }] });
      else year.data.push({ x: yoy.week, y: yoy.count });
      return acc;
    }, []);

  return (
    <ResponsiveLine
      data={data()}
      animate={true}
      xScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      margin={{ top: 20, right: 20, bottom: 50, left: 80 }}
      enableGridY={true}
      enableGridX={true}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "YearWeek",
        legendPosition: "middle",
        legendOffset: 40,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Count",
        legendPosition: "middle",
        legendOffset: -55,
      }}
      colors={{ scheme: "nivo" }}
      enablePoints={false}
      useMesh={true}
      legends={[
        {
          anchor: "top-right",
          direction: "column",
          justify: false,
          translateX: 0,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default YoyAdsGraph;
